export default __webpack_public_path__ + "static/media/pr.a958bbad.svg";